export default "__VITE_ASSET__$R3ti1K7__"